import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import * as LZString from 'lz-string';
import { DataService } from 'src/app/services/data.service';

@Component({
  selector: 'app-localization-key-status',
  templateUrl: './localization-key-status.component.html',
  styleUrls: ['./localization-key-status.component.sass'],
})
export class LocalizationKeyStatusComponent implements OnInit {
  @Input() record: any;
  @Input() field: any;

  loading = true;
  keyExists = true;
  keyValue: string | null = null;

  constructor(private dataService: DataService, private router: Router) {}

  async ngOnInit(): Promise<void> {
    this.keyValue = this.record?.[this.field?.key] || null;

    if (!this.keyValue) {
      this.keyExists = false;
      this.loading = false;
      return;
    }

    try {
      const result: any = await this.dataService.post('/api/localization/client-strings/check-keys', {
        keys: [this.keyValue],
      });
      this.keyExists = !!result?.[this.keyValue];
    } catch {
      // Fail-safe: don't surface a false alarm if the check itself errors out.
      this.keyExists = true;
    } finally {
      this.loading = false;
    }
  }

  get isMissing(): boolean {
    return !this.loading && !this.keyExists;
  }

  get isEnabled(): boolean {
    return !!this.record?.enabled;
  }

  get severity(): 'warning' | 'danger' | null {
    if (!this.isMissing) return null;
    return this.isEnabled ? 'danger' : 'warning';
  }

  get icon(): string {
    return this.severity === 'danger' ? 'pi pi-times-circle' : 'pi pi-exclamation-triangle';
  }

  get tooltip(): string {
    if (this.severity === 'danger') {
      return this.keyValue
        ? 'This localization key is missing from the Client Strings table, and the Minigame is currently enabled.'
        : 'No localization key is set, and the Minigame is currently enabled.';
    }
    return this.keyValue
      ? 'This localization key is missing from the Client Strings table.'
      : 'No localization key is set.';
  }

  goToClientStrings(event: Event): void {
    event.stopPropagation();
    if (this.keyValue) {
      const filterModel = { id: { filterType: 'text', type: 'contains', filter: this.keyValue } };
      const compressed = LZString.compressToEncodedURIComponent(JSON.stringify(filterModel));
      this.router.navigate(['/client-strings'], { queryParams: { filter: compressed } });
    } else {
      this.router.navigate(['/client-strings']);
    }
  }
}
